import { render, staticRenderFns } from "./createTicket.vue?vue&type=template&id=25b1ae7b&scoped=true&"
import script from "./createTicket.vue?vue&type=script&lang=js&"
export * from "./createTicket.vue?vue&type=script&lang=js&"
import style0 from "./createTicket.vue?vue&type=style&index=0&id=25b1ae7b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b1ae7b",
  null
  
)

export default component.exports